import { Component, Input } from '@angular/core';
import { BaseToolComponent } from '../../base-tool.component';
import { FontsLibrairie } from 'src/app/data/fonts.librairie';
import { ApplicationService } from 'src/app/services/application.service';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { TextLayerData } from 'src/app/data/configurator/layer/text-layer.data';
import { TintableLayerData } from 'src/app/data/configurator/layer/tintable-layer.data';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { CommandData } from 'src/app/data/configurator/command.data';
import { ApplicationData } from 'src/app/data/application.data';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from 'src/app/services/modal.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { UserData } from 'src/app/data/user.data';

@Component({
  selector: 'text-panel',
  templateUrl: './text-panel.component.html',
  host: {
    class: 'text-panel'
  }
})
export class TextPanelComponent extends BaseToolComponent {

  public fontImportStep: number = -1;
  public fontProgressRef:string;
  public fontErrorRef:string;

  @Input() set label(data: LabelData) {
    if ((this._labelData && this._labelData != data) || !this._labelData) {
      this.clearCurrentLabel();
      this._labelData = data;
      this.setLabel();
    }
  }

  @Input() set layer(data: LayerData) {
    if (this._layerData != data) {
      this._layerData = data;
      this.setLayer();
    }
  }
  get layerData(): LayerData {
    return this._layerData;
  }

  public hasRegular: boolean = true;
  public hasBold: boolean = false;
  public hasItalic: boolean = false;
  public hasBoldItalic: boolean = false;

  public fonts:Array<any> = [];
  public currentSelectedFont:string;

  /**
	 * Constructor
	 */
  constructor(
    private translateService:TranslateService,
    private applicationService:ApplicationService,
    private applicationData:ApplicationData,
    private modalService:ModalService,
    private userData:UserData,
    private userService:UserService
  ) {
    super();
  }

	/**
	 * On init
	 */
  ngOnInit() {
    FontsLibrairie.loadFont(TextLayerData.DEFAULT_FONT).then(() => {
      this.resetFontList();
      this.currentSelectedFont = this.fonts[0].name;
    });
  }

  resetFontList() {
    for (var key in FontsLibrairie.availableFonts) {
      this.fonts.push(({
        name: FontsLibrairie.availableFonts[key][0].name,
        css: FontsLibrairie.availableFonts[key][0].css
      }));
    }

    this.fonts.sort((f1, f2) => (f1.name > f2.name) ? 1 : -1);
  }

  /**
   * Casting
   */
  asTextLayerData(val): TextLayerData { return val; }

  /**
	 * Set layer
	 */
  protected setLayer(): void {
    if (this._layerData && this._layerData.type == LayerData.TEXT) {
      this.manageFont((<TextLayerData>this._layerData).font);
      TextLayerData.DEFAULT_ALIGN = (<TextLayerData>this._layerData).align;
    }
  }

  /**
	 * Add font
	 */
  public addFont(): void {
    this.fontImportStep = 1;
    this.fontErrorRef = "";
    this.fontProgressRef = "";

    if(this.userData.id > 0){
      this.modalService.open('modal-font-upload', {});
    } else {
      this.userService.invokeLogin().then(()=>{
        this.modalService.open('modal-font-upload', {});
      },(error)=>{
        // Do nothing
      });
    }

  }

  public browseFont(): void {
    let tempDomElmt = document.createElement('div');
    tempDomElmt.style.display = "none";
    tempDomElmt.innerHTML = '<input id="fontBrowser" type="file" value="Parcourir" accept="font/otf, font/ttf, font/woff" />';
    document.body.appendChild(tempDomElmt);


    document.getElementById("fontBrowser").onchange = (e: any) => {

      this.fontProgressRef = 'cfg_textPanel_uploadInfo';

      if (e.target.files && e.target.files[0]) {

        if (["font/otf","font/ttf", "font/woff"].indexOf(e.target.files[0].type) === -1) {
          this.fontProgressRef = ''
          this.fontErrorRef ='cfg_imageImportFail1';
        } else {
            this.userService.uploadFont(e.target.files[0]).then((fontObj)=>{

              let _userFont = {
                "css": fontObj.name,
                "is_bold": false,
                "is_italic": false,
                "is_italic_bold": false,
                "name": fontObj.name,
                "url": environment.USER_FONTS_FOLDER + fontObj.src
              };

              FontsLibrairie.availableFonts[_userFont.css.toUpperCase()] = [_userFont];
              FontsLibrairie.loadFont(_userFont.css.toUpperCase()).then(()=>{
                this.modalService.cancel('modal-font-upload');
                this.resetFontList();
              });

            }, (error)=>{
              this.fontProgressRef = ''
              this.fontErrorRef = error;
            });
        }

      } else {
        //reject("L'utilisateur a annulé l'import.");
      }
    };


    document.getElementById("fontBrowser").click();

  }

  /**
  * Manage font styles
  */
  private manageFont(fontName:string) {
    let fontStyle: any = FontsLibrairie.getStyle(fontName);
    this.hasBold = fontStyle.bold;
    this.hasItalic = fontStyle.italic;
    this.hasBoldItalic = fontStyle.bold && fontStyle.italic;

    if (this._layerData && this._layerData.type == LayerData.TEXT) {
      if ((<TextLayerData>this._layerData).bold && (<TextLayerData>this._layerData).italic && !this.hasBoldItalic) {
        (<TextLayerData>this._layerData).bold = false;
        (<TextLayerData>this._layerData).italic = false;
      }
      if ((<TextLayerData>this._layerData).bold && !this.hasBold) {
        (<TextLayerData>this._layerData).bold = false;
      }
      if ((<TextLayerData>this._layerData).italic && !this.hasItalic) {
        (<TextLayerData>this._layerData).italic = false;
      }

      TextLayerData.DEFAULT_SIZE = (<TextLayerData>this._layerData).size;
      TextLayerData.DEFAULT_FONT = (<TextLayerData>this._layerData).font;
      TextLayerData.DEFAULT_BOLD = (<TextLayerData>this._layerData).bold;
      TextLayerData.DEFAULT_ITALIC = (<TextLayerData>this._layerData).italic;
      TextLayerData.DEFAULT_UNDERLINE = (<TextLayerData>this._layerData).underline;
    }
  }

  /**
	 * setFont
	 */
  public setFont(font: string) {

    if (!FontsLibrairie.loadedFonts[font.toUpperCase()]) {
      FontsLibrairie.loadFont(font).then(() => {
        if (this._layerData) {
          HistoryData.add(this._labelData, this._layerData, CommandData.SET_STYLE, this.getCurrentStyle());
          (<TextLayerData>this._layerData).font = font;
          this.manageFont(font);
          this._layerData.invalidate();
        }
      });
    } else {
      if (this._layerData) {
        HistoryData.add(this._labelData, this._layerData, CommandData.SET_STYLE, this.getCurrentStyle());
        (<TextLayerData>this._layerData).font = font;
        this.manageFont(font);
        this._layerData.invalidate();
      }
    }
    this.currentSelectedFont = font;

  }

  /**
	 * setSize
	 */
  public setSize(size: number) {
    if (this._layerData) {
      HistoryData.add(this._labelData, this._layerData, CommandData.SET_STYLE, this.getCurrentStyle());
      (<TextLayerData>this._layerData).size = size;
      this._layerData.invalidate();
    }
    TextLayerData.DEFAULT_SIZE = size;
  }

  /**
	 * setAlign
	 */
  public setAlign(align: string) {
    if (this._layerData) {
      HistoryData.add(this._labelData, this._layerData, CommandData.SET_STYLE, this.getCurrentStyle());
      (<TextLayerData>this._layerData).align = align;
      this._layerData.invalidate();
    }

    TextLayerData.DEFAULT_ALIGN = align;
  }

  /**
	 * setLeading
	 */
  public setLeading(leading: number) {
    if (this._layerData) {
      HistoryData.add(this._labelData, this._layerData, CommandData.SET_STYLE, this.getCurrentStyle());
      (<TextLayerData>this._layerData).leading = leading;
      this._layerData.invalidate();
    }
  }

  /**
	 * setBold
	 */
  public setBold(value: boolean) {
    console.log("FontPanel : setBold", value);
    if (this._layerData) {
      HistoryData.add(this._labelData, this._layerData, CommandData.SET_STYLE, this.getCurrentStyle());
      (<TextLayerData>this._layerData).bold = value;

      this._layerData.invalidate();
    }
    TextLayerData.DEFAULT_BOLD = value;
    console.log(this._layerData);

  }

  /**
	 * setItalic
	 */
  public setItalic(value: boolean) {
    if (this._layerData) {
      HistoryData.add(this._labelData, this._layerData, CommandData.SET_STYLE, this.getCurrentStyle());
      (<TextLayerData>this._layerData).italic = value;
      this._layerData.invalidate();
    }
    TextLayerData.DEFAULT_ITALIC = value;
  }

  /**
	 * setUnderline
	 */
  public setUnderline(value: boolean) {
    if (this._layerData) {
      HistoryData.add(this._labelData, this._layerData, CommandData.SET_STYLE, this.getCurrentStyle());
      (<TextLayerData>this._layerData).underline = value;
      this._layerData.invalidate();
    }
    TextLayerData.DEFAULT_UNDERLINE = value;
  }

  /**
	 * addTextLayer
	 */
  public addTextLayer() {
    var layerData: LayerData = new TextLayerData(this.translateService.instant('cfg_default_text'), this.currentSelectedFont, TextLayerData.DEFAULT_SIZE, TintableLayerData.DEFAULT_COLOR, TextLayerData.DEFAULT_BOLD, TextLayerData.DEFAULT_ITALIC, TextLayerData.DEFAULT_UNDERLINE, TextLayerData.DEFAULT_ALIGN, 0);
      layerData.rotation = this.applicationData.configuration.currentCanvasRotation.valueOf()*-1;
      this._labelData.addLayer(layerData);

    HistoryData.add(this._labelData, layerData, CommandData.REMOVE_LAYER);

    this.applicationService.currentLayerData = layerData;
  }

  /**
	 * Get current style
	 */
  private getCurrentStyle() {
    return {
      x: (<TextLayerData>this._layerData).x,
      y: (<TextLayerData>this._layerData).y,
      rotation: (<TextLayerData>this._layerData).rotation,
      font: (<TextLayerData>this._layerData).font,
      size: (<TextLayerData>this._layerData).size,
      bold: (<TextLayerData>this._layerData).bold,
      italic: (<TextLayerData>this._layerData).italic,
      underline: (<TextLayerData>this._layerData).underline,
      align: (<TextLayerData>this._layerData).align,
      leading: (<TextLayerData>this._layerData).leading,
      text: (<TextLayerData>this._layerData).text
    };
  }

	/**
	* On destroy
	*/
  ngOnDestroy() {

  }
}
